export default __webpack_public_path__ + "static/media/news_menu_item.b79b25ee.svg";